import React, { useContext, useEffect, useState } from 'react';
import Sidebar from '../../Components/SideBar'
import { Container, Row, Col, Card, ListGroup, InputGroup, FormControl, Button } from 'react-bootstrap';
import Slider from '../../Components/Slider';
import DemoModal from '../../Components/DemoModal/DemoModal';
import ContactModal from '../../Components/ContactModal/ContactModal';
import BannerAlert from '../../Components/BannerAlert/BannerAlert';
import ButtonsHome from '../../Components/ButtonsHome/ButtonsHome';
import iconexplore from '../../Assets/explore.svg'
import SingleCard from '../../Components/SingleCard';
import ButtonsExplore from '../../Components/ButtonsExplore/ButtonsExplore';
import ImageIconLoader from '../../Components/ImageIconLoader';

import iconquestion from '../../Assets/icons/icon-question.svg'
import iconcs from '../../Assets/icons/icon-cs.svg'
import Annoucements from '../../Components/Annoucements/Annoucements';
import { ExploreContext } from '../../Context/ExploreContext';
import { App, Tag } from '../../interface';
const Index: React.FC = () => {
  const [collapsed, setCollapsed] = useState(false);
  const images = [
    'https://via.placeholder.com/800x400.png?text=First+Slide',
    'https://via.placeholder.com/800x400.png?text=Second+Slide',
    'https://via.placeholder.com/800x400.png?text=Third+Slide'
  ];

  const toggleSidebar = () => {
    setCollapsed(!collapsed);
  };
  const items = [
    { id: 1, text: "Item 1", imgSrc: "../../Assets/explore.svg" },
    { id: 2, text: "Item 2", imgSrc: "/path/to/image2.jpg" },
    { id: 3, text: "Item 3", imgSrc: "/path/to/image3.jpg" },

  ];

  const [data, setData] = useState<App[]>([]);
  const [showModal, setShowModal] = useState(false);
  const handleModal = () => setShowModal(!showModal);
  const [dataDemo, setDataDemo] = useState<any>([]);
  const [showModalContact, setShowModalContact] = useState(false);
  const handleModalContact = () => setShowModalContact(!showModalContact);
  const { getAllApps } = useContext(ExploreContext);
  const [searchTerm, setSearchTerm] = useState<string>('');
  const [filteredData, setFilteredData] = useState<App[]>([]);
  const [tagSelected, setTagSelected] = useState<string>();
  const [uniqueTags, setUniqueTags] = useState<Tag[]>([]);
  useEffect(() => {
    const getData = async () => {
      const aValue = localStorage.getItem("okta-token-storage")!;
      const oktadata = JSON.parse(aValue);
      const okta_id = oktadata.idToken.claims.sub;
      let apps = await getAllApps(okta_id)
      const tags = getUniqueTags(apps);
      setUniqueTags(tags)
      setData(apps);
      setFilteredData(apps);
    }
    getData()
  }, []);


  function getUniqueTags(apps: App[]): Tag[] {
    const tagMap = new Map<string, Tag>();

    apps.forEach(app => {
      app.tags?.forEach(tag => {
        if (!tagMap.has(tag.tag_description)) {
          tagMap.set(tag.tag_description, tag);
        }
      });
    });

    return Array.from(tagMap.values());
  }

  // Function to chunk the data into arrays of 5 items
  const chunkData = (array: App[], chunkSize: number): App[][] => {
    const result: App[][] = [];
    for (let i = 0; i < array.length; i += chunkSize) {
      result.push(array.slice(i, i + chunkSize));
    }
    return result;
  };
  const handleSearch = (event: any) => {
    setTagSelected('')
    const term = event.target.value;
    setSearchTerm(term);
    if (term === '') {
      setFilteredData(data);
    } else {
      const filtered = data.filter(app => app.app_name?.toLowerCase().includes(term.toLowerCase()));
      setFilteredData(filtered);
    }
  };

  const handleSearchTag = (tagDescription: string) => {
    setSearchTerm('');
    if (tagDescription === '' || tagDescription == tagSelected) {
      setFilteredData(data);
      setTagSelected('')
    } else {
      setTagSelected(tagDescription)
      const filtered = data.filter(app =>
        app.tags?.some(tag => tag.tag_description === tagDescription)
      );
      setFilteredData(filtered);
    }
  };
  const openURL = (url: string) => {
    window.open(url, '_blank', 'noopener,noreferrer');
  };
  const handleResize = () => {
    if (window.innerWidth <= 1000) {
      setCollapsed(true);
    } else {
      setCollapsed(false);
    }
  };
  const handleMultipleApps = (id: number) => {

  }
  useEffect(() => {
    window.addEventListener('resize', handleResize);
    handleResize(); // Para ajustar al tamaño actual al montar el componente

    return () => window.removeEventListener('resize', handleResize);
  }, []);
  return (
    <Container fluid>

      <Row>
        <Col className="p-0" style={{ "maxWidth": collapsed ? '80px' : '350px' }}>
          {/* <Sidebar collapsed={collapsed} onToggle={toggleSidebar} handleMultipleApps={handleMultipleApps} /> */}
        </Col>
        <Col className="p-3 transition-all " >
          {/* <BannerAlert /> */}
          <div className='mb-4 '>
            <div className='d-flex'>
              <Col className="mb-3 mx-1">
                <Card className='min-420 border-0'>
                  <h1 className='fs-70 fw-bolds'>
                    Explore.<br></br> Discover.<br></br> Enjoy.
                  </h1>
                  <Button className='bg-6 border-0 text-start fw-bold my-1 w-110' onClick={() => openURL('https://www.graydi.us/case-studies')} ><img src={iconquestion} alt="" /> Case Studies</Button>
                  <Button className='bg-10 border-0 text-start fw-bold my-1 w-110' onClick={() => openURL('https://www.graydi.us/case-studies')} > <img src={iconcs} alt="" /> Question of the day</Button>
                </Card>
              </Col>

              <Col md={4} className="mb-3 mx-1">
                <Card className='min-420 border-0'>
                  <img src={require('../../Assets/explore/Imagen3.png')} alt="" className='img-fluid' />
                </Card>
              </Col>
              {/* <Col className="mb-3 mx-1">
                <Card className='min-420'>
                  <img src="" alt="" />
                </Card>
              </Col> */}
              <Col className="mb-3 mx-1">
                <Card className='min-420 border-0'>
                  <img src={require('../../Assets/explore/Imagen1.png')} alt="" className='img-fluid' />
                </Card>
              </Col>
              <Col className="mb-3 mx-1">
                <Card className='min-420 border-0'>
                  <img src={require('../../Assets/explore/Imagen2.png')} alt="" className='img-fluid' />
                </Card>
              </Col>
            </div>
            <div className='my-2 w-100 '>
              <Row>
                <Col md={2}></Col>
                <Col md={8} className='d-flex justify-content-center '> <h4>We have an app for every need you may have!</h4></Col>
                <Col md={2}><InputGroup className="search-input">
                  <FormControl placeholder="Search"
                    value={searchTerm}
                    onChange={handleSearch} />
                  <InputGroup.Text className="search-icon">
                    <ImageIconLoader name={"iconsearch"} alt="" width={30} />
                  </InputGroup.Text>
                </InputGroup></Col>


              </Row>

            </div>
            <div className='my-2 w-100 d-flex justify-content-center '>
              <ButtonsExplore data={uniqueTags} handleSearchTag={handleSearchTag} tagSelected={tagSelected} />
            </div>
            <div className='my-5 container'>
              <div className="mb-3 d-flex flex-wrap">
                {filteredData && filteredData.map((item, itemIndex) => (
                  <div key={itemIndex} className="mb-3 me-3"  >
                    <a className='text-decoration-none cursor-pointer'
                      onClick={() => {
                        handleModal()
                        setDataDemo(item)
                      }}>
                      <SingleCard variant={1} data={item} fav={false} />
                    </a>

                  </div>
                ))}
              </div>




            </div>
          </div>

          <Annoucements />
          <Row>
            <Col md={12}>
              <h3>Our recommendations</h3>
              <p>This are some of the most popular apps for users like you</p>
            </Col>
            {data && data.map((app) => {
              if (app.is_recommended) {
                return (
                  <Col md={6}>
                    <div className='border-bottom mx-3 mb-3'>
                      <Row>
                        <Col md={9}>
                          <h3>{app.app_name}</h3>
                          <p>
                            Description lorem epsum lorem epsum lorem epsum etc etc.
                          </p>
                        </Col>

                        <Col md={3} className='px-2'>
                          <Button className='bg-5 fw-bold text-blue border-0' variant="primary" onClick={() => handleModalContact()}>Contact Sales</Button>
                          <Button variant="light" onClick={() => openURL(app.demo_link?app.demo_link:'')}>Try demo</Button>
                        </Col>
                      </Row>
                    </div>
                  </Col>)
              }
            })}


          </Row>

        </Col>
      </Row>

      <DemoModal showModal={showModal} handleModal={handleModal} dataDemo={dataDemo} handleModalContact={handleModalContact} />
      <ContactModal showModal={showModalContact} handleModal={handleModalContact} />
    </Container >
  )
}

export default Index